import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, states } from '@/utils'

import button from '@/components/button'
import fileDrop from '@/components/file/drop'
import fileCard from '@/components/file/item/card'
import fileManager from '@/components/file/manager'
import selectorOwner from '@/components/selector/owner'
import signMethod from '@/components/services/contracts/commons/signMethod'
import sticker from '@/components/sticker'
import tag from '@/components/tag'
import owner from '@/components/templates/service/item/owner'
import textOverflow from '@/components/text/overflow'

function renderTitleField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.title,
        label: this.getTranslate(`${Services.contracts}.labels.title`),
        dense: true,
        required: true,
        clearable: true,
        autofocus: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.title = event
        }
      }
    }
  )
}
function renderSignMethodField(h) {
  return h(
    signMethod,
    {
      props: {
        value: this.proxy.signMethod
      },
      on: {
        input: event => {
          this.proxy.signMethod = event
        }
      }
    }
  )
}

function renderTaxSystemTag(h, serviceName, vat) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${serviceName}.vat.${vat}`),
        color: Colors.primary,
        as: 'select-dense'
      }
    }
  )
}
function renderSelectionTag(h, label) {
  return h(
    tag,
    {
      props: {
        label,
        as: 'select-dense'
      }
    }
  )
}
function renderSelectSelectionLayout(h, primaryContent, secondaryContent) {
  return h(
    'div',
    {
      class: `${Services.contracts}-form__select-row ${Services.contracts}-form__select-row--selection`
    },
    [ primaryContent, secondaryContent ]
  )
}
function renderTaxedSelection(h, optionData, serviceName) {
  return renderSelectSelectionLayout.call(
    this,
    h,
    renderSelectionTag.call(this, h, optionData.label),
    renderTaxSystemTag.call(this, h, serviceName, optionData.vat)
  )
}
function renderSelectItemText(h, title, subtitle) {
  const children = [
    h(
      textOverflow,
      {
        props: {
          value: title
        }
      }
    )
  ]

  if (subtitle) {
    children.push(
      h(
        textOverflow,
        {
          class: `${Services.contracts}-form__select-subtitle`,
          props: {
            value: subtitle
          }
        }
      )
    )
  }

  return h(
    'div',
    {
      class: `${Services.contracts}-form__select-content`
    },
    [ children ]
  )
}
function renderSelectItemLayout(h, primaryContent, secondaryContent) {
  return h(
    'div',
    {
      class: `${Services.contracts}-form__select-row ${Services.contracts}-form__select-row--item`
    },
    [ primaryContent, secondaryContent ]
  )
}
function renderTaxedItem(h, optionData, serviceName) {
  return renderSelectItemLayout.call(
    this,
    h,
    renderSelectItemText.call(this, h, optionData.title, optionData.subtitle),
    renderTaxSystemTag.call(this, h, serviceName, optionData.vat)
  )
}
function renderOwnerField(h) {
  if (this.isNew || !this.value.Owner) {
    return h(
      selectorOwner,
      {
        props: {
          value: this.proxy.OwnerId,
          disabled: !this.isNew && !!this.value.OwnerId,
          dense: true
        },
        on: {
          input: event => {
            this.proxy.OwnerId = event
          }
        }
      }
    )
  }

  return h(
    owner,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderRequisiteField(h) {
  if (this.isNew || !this.value.Requisite) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy.RequisiteId,
          label: this.getTranslate(`${Services.contracts}.labels.requisite`),
          service: Services.requisites,
          query: { OwnerId: this.proxy.OwnerId },
          picks: [ 'id', 'title', 'data' ],

          disabled: !this.proxy.OwnerId || !this.isNew && !!this.value.Requisite,
          dense: true,
          clearable: true,
          autocomplete: true,
          details: false
        },
        scopedSlots: {
          selection: ({ item }) => {
            return renderTaxedSelection.call(this, h, this.getRequisiteOptionData(item), Services.requisites)
          },
          item: ({ item }) => {
            return renderTaxedItem.call(this, h, this.getRequisiteOptionData(item), Services.requisites)
          }
        },
        on: {
          input: event => {
            this.proxy.RequisiteId = event
          }
        }
      }
    )
  }

  if (this.value.Requisite) {
    return h(
      sticker,
      {
        props: {
          value: this.value.Requisite,
          label: this.getTranslate(`${Services.contracts}.labels.requisite`),
          icon: icons.class,
          color: Colors.grey,
          service: Services.requisites
        }
      }
    )
  }
}
function renderCompanyField(h) {
  if (this.isNew || !this.value.Company) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy.CompanyId,
          label: this.getTranslate(`${Services.contracts}.labels.company`),
          service: Services.companies,
          query: {
            OwnerId: '$global',
            vat: this.vat
          },
          picks: [ 'id', 'title', 'vat' ],

          disabled: !this.proxy.OwnerId || !this.isNew && !!this.value.Company,
          dense: true,
          clearable: true,
          autocomplete: true,
          details: false
        },
        scopedSlots: {
          selection: ({ item }) => {
            return renderTaxedSelection.call(this, h, this.getCompanyOptionData(item), Services.companies)
          },
          item: ({ item }) => {
            return renderTaxedItem.call(this, h, this.getCompanyOptionData(item), Services.companies)
          }
        },
        on: {
          input: event => {
            this.proxy.CompanyId = event
          }
        }
      }
    )
  }

  if (this.value.Company) {
    return h(
      sticker,
      {
        props: {
          value: this.value.Company,
          label: this.getTranslate(`${Services.contracts}.labels.company`),
          icon: icons.class,
          color: Colors.grey,
          service: Services.companies
        }
      }
    )
  }
}

function renderFileDrop(h) {
  return h(
    fileDrop,
    {
      class: `${Services.contracts}-form__drop`,
      props: {
        accepted: [ 'doc', 'docx' ],
        name: 'file',
        loading: this.uploadState === states.loading
      },
      on: {
        click: () => {
          this.showFileManager = true
        }
      }
    }
  )
}
function renderFileCard(h) {
  return h(
    fileCard,
    {
      props: {
        value: this.proxy.FileId,
        outline: true,
        displayMenu: !this.isNew,
        flat: true,
        maxWidth: '100%',
        small: true,
        include: [ 'download', 'export' ]
      }
    }
  )
}
function renderFileClearButton(h) {
  if (this.isNew) {
    return h(
      button,
      {
        props: {
          icon: icons.clear,
          mode: buttonModes.flat
        },
        on: {
          click: () => {
            this.proxy.FileId = undefined
          }
        }
      }
    )
  }
}
function renderFile(h) {
  if (this.proxy.FileId) {
    return h(
      'div',
      {
        class: {
          [`${Services.contracts}-form__file-card`]: true,
          [`${Services.contracts}-form__file-card--clearable`]: this.isNew
        }
      },
      [
        renderFileCard.call(this, h),
        renderFileClearButton.call(this, h)
      ]
    )
  }

  return h(
    'div',
    {
      class: `${Services.contracts}-form__drop-holder`
    },
    [ renderFileDrop.call(this, h) ]
  )
}

function renderFileManager(h) {
  return h(
    fileManager,
    {
      props: {
        show: this.showFileManager,
        currentChosenFileId: this.proxy.FileId,
        flat: true,
        embedded: true,
        readonly: true,
        types: [ 'doc', 'docx' ]
      },
      on: {
        show: event => {
          this.showFileManager = event
        },
        input: event => {
          this.showFileManager = false
          this.proxy.FileId = event.id
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${Services.contracts}-form`]: true,
        [`${Services.contracts}-form--new`]: this.isNew
      }
    },
    [
      renderTitleField.call(this, h),
      renderSignMethodField.call(this, h),
      renderOwnerField.call(this, h),
      renderRequisiteField.call(this, h),
      renderCompanyField.call(this, h),
      renderFile.call(this, h),
      renderFileManager.call(this, h)
    ]
  )
}
